module.exports = __webpack_public_path__ + "img/login-vector.26754f31.svg";